// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  encounterId: __t.u64().primaryKey().name("encounter_id"),
  worldId: __t.u64().name("world_id"),
  kit: __t.string(),
  hour: __t.u8(),
  weather: __t.string(),
  viewSeed: __t.u32().name("view_seed"),
  layoutSeed: __t.u64().name("layout_seed"),
  season: __t.u8(),
  country: __t.string(),
  look: __t.string(),
});
